import { render, staticRenderFns } from "./download-instagram-reels-iphone-android.vue?vue&type=template&id=1fdb3e40"
import script from "./download-instagram-reels-iphone-android.vue?vue&type=script&lang=js"
export * from "./download-instagram-reels-iphone-android.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports